webpackJsonp([2,33],{

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(9), __esModule: true };

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(11);
	module.exports = __webpack_require__(5).Object.keys;


/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(13);
	var core = __webpack_require__(5);
	var fails = __webpack_require__(14);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(15);
	var $keys = __webpack_require__(16);
	
	__webpack_require__(10)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'MktpMenu',
	  components: {},
	  data: function data() {
	    return {
	      mktp_orders: 0
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    user: function user(state) {
	      return state.user;
	    }
	  })),
	  mounted: function mounted() {},
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)([]))
	};

/***/ }),

/***/ 481:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'AlertPanelNotification',
	  props: {
	    alert: {
	      type: Object,
	      required: true
	    }
	  },
	  computed: {
	    companyName: function companyName() {
	      if (this.alert.data.company.fantasy_name) return this.alert.data.company.fantasy_name;
	      if (this.alert.data.company.company_name) return this.alert.data.company.company_name;
	    }
	  },
	  methods: {
	    close: function close(alert) {
	      var navigatorTo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (navigatorTo) {
	        this.$router.push({ name: 'home' });
	      }
	      this.$emit('decreaseNotification', alert);
	    }
	  }
	};

/***/ }),

/***/ 482:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'BalanceAlertNotification',
	  props: {
	    alert: {
	      type: Object,
	      required: true
	    }
	  },
	  methods: {
	    close: function close() {
	      this.$emit('decreaseNotification', this.alert);
	    },
	    navigatoToBuyCredit: function navigatoToBuyCredit() {
	      this.$router.push({ name: 'finances_dashboard', query: { buy_credit: true } });
	      this.$emit('decreaseNotification', this.alert);
	    }
	  }
	};

/***/ }),

/***/ 483:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'BaseNotifications',
	  props: {
	    fa_icon: {
	      type: String,
	      required: true
	    }
	  }
	};

/***/ }),

/***/ 484:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'CertificateReadyNotification',
	  props: {
	    certificate: {
	      type: Object,
	      required: true
	    }
	  },
	  methods: {
	    navigatoToCertificate: function navigatoToCertificate() {
	      if (this.$route.name === 'clients_add') {
	        this.$router.push({ name: 'clients_add', params: { clientId: this.certificate.id }, query: { showCertificate: true } });
	      } else {
	        this.$router.push({ name: 'clients_details', params: { clientId: this.certificate.id }, query: { showCertificate: true } });
	      }
	      this.$emit('decreaseNotification', this.certificate);
	    },
	    getName: function getName(type) {
	      var data = this.getCertificateTypes();
	      return data[type];
	    },
	    close: function close() {
	      this.$emit('decreaseNotification', this.certificate);
	    }
	  }
	};

/***/ }),

/***/ 485:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'name': 'NotifyBoletoPayment',
	  props: {
	    notify: {
	      type: Object,
	      required: true
	    }
	  },
	  methods: {
	    navigatoTo: function navigatoTo() {
	      this.$router.push({ name: 'rents_details', params: { rentId: this.notify.rent_id } });
	      this.$emit('decreaseNotification', this.notify);
	    },
	    close: function close() {
	      this.$emit('decreaseNotification', this.notify);
	    }
	  }
	};

/***/ }),

/***/ 486:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'NotifyUserOnCliet',
	  props: {
	    notifyUser: {
	      type: Object,
	      required: true
	    }
	  },
	  methods: {
	    navigatoTo: function navigatoTo() {
	      if (this.$route.name === 'clients_add') {
	        this.$router.push({ name: 'clients_add', params: { clientId: this.notifyUser.client.id } });
	      } else {
	        this.$router.push({ name: 'clients_details', params: { clientId: this.notifyUser.client.id } });
	      }
	      this.$emit('decreaseNotification', this.notifyUser);
	    },
	    close: function close() {
	      this.$emit('decreaseNotification', this.notifyUser);
	    }
	  }
	};

/***/ }),

/***/ 487:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'PixNotification',
	  props: {
	    pix: {
	      type: Object,
	      required: true
	    }
	  },
	  methods: {
	    close: function close(pix) {
	      var navigatorTo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (navigatorTo) {
	        this.$router.push({ name: 'finances_dashboard' });
	      }
	      this.$emit('decreaseNotification', pix);
	    }
	  }
	};

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(4);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _BalanceAlertNotification = __webpack_require__(687);
	
	var _BalanceAlertNotification2 = _interopRequireDefault(_BalanceAlertNotification);
	
	var _PixNotification = __webpack_require__(692);
	
	var _PixNotification2 = _interopRequireDefault(_PixNotification);
	
	var _CertificateReadyNotification = __webpack_require__(689);
	
	var _CertificateReadyNotification2 = _interopRequireDefault(_CertificateReadyNotification);
	
	var _BaseNotifications = __webpack_require__(688);
	
	var _BaseNotifications2 = _interopRequireDefault(_BaseNotifications);
	
	var _AlertPanelNotification = __webpack_require__(686);
	
	var _AlertPanelNotification2 = _interopRequireDefault(_AlertPanelNotification);
	
	var _NotifyUserOnClient = __webpack_require__(691);
	
	var _NotifyUserOnClient2 = _interopRequireDefault(_NotifyUserOnClient);
	
	var _NotifyBoletoPayment = __webpack_require__(690);
	
	var _NotifyBoletoPayment2 = _interopRequireDefault(_NotifyBoletoPayment);
	
	var _vuex = __webpack_require__(1);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { BalanceAlertNotification: _BalanceAlertNotification2.default, PixNotification: _PixNotification2.default, CertificateReadyNotification: _CertificateReadyNotification2.default, BaseNotifications: _BaseNotifications2.default, AlertPanelNotification: _AlertPanelNotification2.default, NotifyUserOnClient: _NotifyUserOnClient2.default, NotifyBoletoPayment: _NotifyBoletoPayment2.default },
	  name: 'GeneralNotifications',
	  data: function data() {
	    return {
	      lodash: _lodash2.default,
	      screeAvailHeight: 0
	    };
	  },
	
	  watch: {
	    notifications: function notifications(to, from) {
	      this.updateScreenHeigthForDropdowMenu();
	    }
	  },
	  mounted: function mounted() {
	    this.listenEvents();
	    this.updateScreenHeigthForDropdowMenu();
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    newNotification: function newNotification(state) {
	      return state.notifictionsGeneral;
	    },
	    user: function user(state) {
	      return state.user;
	    },
	    notifications: function notifications(state) {
	      return state.notifications;
	    }
	  }), {
	    hasNotifications: function hasNotifications() {
	      return this.notifications.length > 0;
	    }
	  }),
	  methods: (0, _extends3.default)({
	    updateScreenHeigthForDropdowMenu: function updateScreenHeigthForDropdowMenu() {
	      this.screeAvailHeight = this.notifications.length > 0 ? window.screen.availHeight - 200 : 40;
	      var dynamicHeigth = this.getElementHeigth() > 0 ? this.getElementHeigth() : this.screeAvailHeight;
	      if (dynamicHeigth < this.screeAvailHeight) this.screeAvailHeight = dynamicHeigth;
	    },
	    getElementHeigth: function getElementHeigth() {
	      var elementOfList = this.$refs.dropdown;
	      var elementOfListUl = elementOfList.getElementsByClassName('card');
	      var heightCard = 0;
	      if (elementOfListUl.length > 0) {
	        this.lodash.forEach(elementOfListUl, function (card, key) {
	          heightCard += card.offsetHeight;
	        });
	      }
	      return heightCard;
	    },
	    listenEvents: function listenEvents() {
	      var _this = this;
	
	      var eventsMap = {
	        '.App\\Events\\NotifyUserOnClientStatusChange': { method: 'addNotifications', notifyAll: false },
	        '.App\\Events\\NotifyUserOnClientCreation': { method: 'addNotifications', notifyAll: false },
	        '.App\\Events\\BalanceAlertNotification': { method: 'addNotifications', notifyAll: true },
	        '.App\\Events\\PixPaymentConfirmed': { method: 'showNotificationPaidPix', notifyAll: true },
	        '.App\\Events\\CertificateReceived': { method: 'addNotifications', notifyAll: true },
	        '.App\\Events\\CertificateCreationFailed': { method: 'addNotifications', notifyAll: true },
	        '.App\\Events\\NotifyBoletoPayment': { method: 'addNotifications', notifyAll: true }
	      };
	      (0, _keys2.default)(eventsMap).forEach(function (event) {
	        window.Channel.listen(event, function (e) {
	          var eventScoped = eventsMap[event];
	          if (_this[eventScoped.method] && typeof _this[eventScoped.method] === 'function') {
	            if (eventScoped.notifyAll) {
	              _this[eventScoped.method](e);
	            } else {
	              if (_this.user.id !== e.actionedByUser.id) _this[eventScoped.method](e);
	            }
	          }
	        });
	      });
	      window.Channel.alertPanel.listen('.App\\Events\\RestrictionNotification', function (e) {
	        _this.addNotificationRestriction(e);
	      });
	    },
	    showNotificationPaidPix: function showNotificationPaidPix(event) {
	      if (this.$route.name !== 'finances_dashboard') {
	        this.addNotifications(event);
	      }
	    },
	    addNotifications: function addNotifications(event) {
	      this.changeNotificationsGeneral('add');
	      this.pushNotifications(event);
	    },
	    addNotificationRestriction: function addNotificationRestriction(event) {
	      var hasCompanyCurrent = event.data.company.id === this.user.company.id;
	      if (!hasCompanyCurrent) {
	        this.changeNotificationsGeneral('add');
	        this.pushNotifications(event);
	      }
	    },
	    decreaseNotification: function decreaseNotification(event) {
	      this.decreaseNotifications(event);
	    },
	    clearNewsNotifications: function clearNewsNotifications() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        _this2.changeNotificationsGeneral('clear');
	      }, 500);
	    }
	  }, (0, _vuex.mapActions)(['changeNotificationsGeneral', 'pushNotifications', 'decreaseNotifications']))
	};

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  computed: (0, _extends3.default)({
	    routeName: function routeName() {
	      return this.$route.name || '';
	    }
	  }, (0, _vuex.mapState)({
	    newClients: function newClients(state) {
	      return state.newClients;
	    },
	    recentClients: function recentClients(state) {
	      return state.recentClients;
	    },
	    user: function user(state) {
	      return state.user;
	    }
	  })),
	  mounted: function mounted() {
	    this.listenEvents();
	    this.getNewClientsNotifications();
	  },
	
	  methods: (0, _extends3.default)({
	    getNewClientsNotifications: function getNewClientsNotifications() {
	      var _this = this;
	
	      this.$http.get('company_clients/count/' + this.user.company.id).then(function (response) {
	        _this.changeNewClients(response.data.count);
	      });
	    },
	    changeClientRegistred: function changeClientRegistred(e) {
	      if (e) this.changeNewClients(e);
	    },
	    listenEvents: function listenEvents() {
	      var _this2 = this;
	
	      window.Channel.listen('.App\\Events\\AdminClientAddingViaApp', function (e) {
	        _this2.changeClientRegistred(e.quantity);
	      });
	      window.Channel.listen('.App\\Events\\SendUpdateUiAfterReleasing', function (e) {
	        _this2.changeNewClients(e.quantity);
	      });
	    }
	  }, (0, _vuex.mapActions)(['changeNewClients']))
	};

/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _config = __webpack_require__(12);
	
	var config = _interopRequireWildcard(_config);
	
	var _vuex = __webpack_require__(1);
	
	var _MktpMenu = __webpack_require__(675);
	
	var _MktpMenu2 = _interopRequireDefault(_MktpMenu);
	
	var _GeneralNotifications = __webpack_require__(694);
	
	var _GeneralNotifications2 = _interopRequireDefault(_GeneralNotifications);
	
	var _RegistrationsMenu = __webpack_require__(695);
	
	var _RegistrationsMenu2 = _interopRequireDefault(_RegistrationsMenu);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'PartialDrawerNavigation',
	  components: { MktpMenu: _MktpMenu2.default, GeneralNotifications: _GeneralNotifications2.default, RegistrationsMenu: _RegistrationsMenu2.default },
	  data: function data() {
	    return {
	      locashopURL: config.locashopURL
	    };
	  },
	
	  computed: (0, _extends3.default)({
	    routeName: function routeName() {
	      return this.$route.name || '';
	    },
	    apiDomain: function apiDomain() {
	      return config.apiDomain;
	    }
	  }, (0, _vuex.mapState)({
	    notificationsPanel: function notificationsPanel(state) {
	      return state.notificationsPanel;
	    },
	    recentClients: function recentClients(state) {
	      return state.recentClients;
	    },
	    user: function user(state) {
	      return state.user;
	    }
	  })),
	  mounted: function mounted() {
	    window.$('.dropdown', this.$el).click(function (e) {
	      e.stopPropagation();
	    });
	  },
	
	  methods: (0, _extends3.default)({
	    handleLogout: function handleLogout() {
	      this.unsubscribeChannel();
	      this.unsetUser();
	      this.$router.push({ name: 'login' });
	    },
	    toggleDrawer: function toggleDrawer() {
	      this.$emit('toggle-drawer', true);
	    }
	  }, (0, _vuex.mapActions)(['unsetUser']))
	};

/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".card[data-v-04f370aa]:hover{background:#f5f8fa;border-radius:8px}.card[data-v-04f370aa]{padding:10px;cursor:pointer}", "", {"version":3,"sources":["/./src/components/app/general_notification_components/BaseNotifications.vue"],"names":[],"mappings":"AACA,6BACE,mBAAoB,AACpB,iBAAmB,CACpB,AACD,uBACE,aAAc,AACd,cAAgB,CACjB","file":"BaseNotifications.vue","sourcesContent":["\n.card[data-v-04f370aa]:hover {\n  background: #f5f8fa;\n  border-radius: 8px;\n}\n.card[data-v-04f370aa] {\n  padding: 10px;\n  cursor: pointer;\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".card[data-v-29e0f4d8]:hover{background:#f5f8fa;border-radius:8px}.card[data-v-29e0f4d8]{padding:10px;cursor:pointer}a[data-v-29e0f4d8]{color:#777}.icon[data-v-29e0f4d8]{color:#189ce2;border-color:#168ccb;font-size:1.8rem}", "", {"version":3,"sources":["/./src/components/app/general_notification_components/CertificateReadyNotification.vue"],"names":[],"mappings":"AACA,6BACA,mBAAoB,AACpB,iBAAmB,CAClB,AACD,uBACA,aAAc,AACd,cAAgB,CACf,AACD,mBACA,UAAe,CACd,AACD,uBACA,cAAe,AACf,qBAAsB,AACtB,gBAAkB,CACjB","file":"CertificateReadyNotification.vue","sourcesContent":["\n.card[data-v-29e0f4d8]:hover {\nbackground: #f5f8fa;\nborder-radius: 8px;\n}\n.card[data-v-29e0f4d8] {\npadding: 10px;\ncursor: pointer;\n}\na[data-v-29e0f4d8] {\ncolor: #777777;\n}\n.icon[data-v-29e0f4d8] {\ncolor: #189ce2;\nborder-color: #168ccb;\nfont-size: 1.8rem;\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "a[data-v-78ecede0]{color:#777}.icon[data-v-78ecede0]{color:#189ce2;border-color:#168ccb;font-size:1.8rem;margin:-5px}", "", {"version":3,"sources":["/./src/components/app/general_notification_components/AlertPanelNotification.vue"],"names":[],"mappings":"AACA,mBACI,UAAe,CAClB,AACD,uBACI,cAAe,AACf,qBAAsB,AACtB,iBAAkB,AACrB,WAAa,CACb","file":"AlertPanelNotification.vue","sourcesContent":["\na[data-v-78ecede0] {\n    color: #777777;\n}\n.icon[data-v-78ecede0] {\n    color: #189ce2;\n    border-color: #168ccb;\n    font-size: 1.8rem;\n\tmargin: -5px;\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 613:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "a[data-v-7be53da8]{color:#777}.icon[data-v-7be53da8]{color:#189ce2;border-color:#168ccb;font-size:1.8rem;margin:-5px}", "", {"version":3,"sources":["/./src/components/app/general_notification_components/BalanceAlertNotification.vue"],"names":[],"mappings":"AACA,mBACI,UAAe,CAClB,AACD,uBACI,cAAe,AACf,qBAAsB,AACtB,iBAAkB,AACrB,WAAa,CACb","file":"BalanceAlertNotification.vue","sourcesContent":["\na[data-v-7be53da8] {\n    color: #777777;\n}\n.icon[data-v-7be53da8] {\n    color: #189ce2;\n    border-color: #168ccb;\n    font-size: 1.8rem;\n\tmargin: -5px;\n}\n\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".partial-header.navbar .bell-badge[data-v-b55c9b82]{margin-left:-9px}", "", {"version":3,"sources":["/./src/components/app/itens_menu/GeneralNotifications.vue"],"names":[],"mappings":"AACA,oDACE,gBAAmB,CACpB","file":"GeneralNotifications.vue","sourcesContent":["\n.partial-header.navbar .bell-badge[data-v-b55c9b82] {\n  margin-left: -09px;\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "a,a:hover{color:#777}.icon{color:#189ce2;border-color:#168ccb;font-size:1.8rem;margin:-5px}", "", {"version":3,"sources":["/./src/components/app/general_notification_components/NotifyUserOnClient.vue"],"names":[],"mappings":"AAIA,UACI,UAAe,CAClB,AACD,MACI,cAAe,AACf,qBAAsB,AACtB,iBAAkB,AACrB,WAAa,CACb","file":"NotifyUserOnClient.vue","sourcesContent":["\na:hover {\n    color: #777777;\n}\na {\n    color: #777777;\n}\n.icon {\n    color: #189ce2;\n    border-color: #168ccb;\n    font-size: 1.8rem;\n\tmargin: -5px;\n}\n\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".icon[data-v-fff09f06]{color:#189ce2;border-color:#168ccb;font-size:1.8rem;margin:-5px}", "", {"version":3,"sources":["/./src/components/app/general_notification_components/PixNotification.vue"],"names":[],"mappings":"AACA,uBACI,cAAe,AACf,qBAAsB,AACtB,iBAAkB,AACrB,WAAa,CACb","file":"PixNotification.vue","sourcesContent":["\n.icon[data-v-fff09f06] {\n    color: #189ce2;\n    border-color: #168ccb;\n    font-size: 1.8rem;\n\tmargin: -5px;\n}\n\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 621:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(603);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-04f370aa&scoped=true!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseNotifications.vue", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-04f370aa&scoped=true!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseNotifications.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(606);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-29e0f4d8&scoped=true!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CertificateReadyNotification.vue", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-29e0f4d8&scoped=true!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CertificateReadyNotification.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(612);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-78ecede0&scoped=true!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AlertPanelNotification.vue", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-78ecede0&scoped=true!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AlertPanelNotification.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 633:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(613);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-7be53da8&scoped=true!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BalanceAlertNotification.vue", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-7be53da8&scoped=true!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BalanceAlertNotification.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(616);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-b55c9b82&scoped=true!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GeneralNotifications.vue", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-b55c9b82&scoped=true!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GeneralNotifications.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(617);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-c4aa1f4a!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NotifyUserOnClient.vue", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-c4aa1f4a!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NotifyUserOnClient.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(619);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-fff09f06&scoped=true!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PixNotification.vue", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-fff09f06&scoped=true!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PixNotification.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(468)
	
	/* template */
	var __vue_template__ = __webpack_require__(785)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(632)
	
	/* script */
	__vue_exports__ = __webpack_require__(481)
	
	/* template */
	var __vue_template__ = __webpack_require__(839)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-78ecede0"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(633)
	
	/* script */
	__vue_exports__ = __webpack_require__(482)
	
	/* template */
	var __vue_template__ = __webpack_require__(843)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7be53da8"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(621)
	
	/* script */
	__vue_exports__ = __webpack_require__(483)
	
	/* template */
	var __vue_template__ = __webpack_require__(769)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-04f370aa"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(626)
	
	/* script */
	__vue_exports__ = __webpack_require__(484)
	
	/* template */
	var __vue_template__ = __webpack_require__(798)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-29e0f4d8"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(485)
	
	/* template */
	var __vue_template__ = __webpack_require__(840)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(637)
	
	/* script */
	__vue_exports__ = __webpack_require__(486)
	
	/* template */
	var __vue_template__ = __webpack_require__(858)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 692:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(639)
	
	/* script */
	__vue_exports__ = __webpack_require__(487)
	
	/* template */
	var __vue_template__ = __webpack_require__(874)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-fff09f06"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 694:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(636)
	
	/* script */
	__vue_exports__ = __webpack_require__(489)
	
	/* template */
	var __vue_template__ = __webpack_require__(852)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b55c9b82"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 695:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(490)
	
	/* template */
	var __vue_template__ = __webpack_require__(826)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 763:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(564)
	
	/* template */
	var __vue_template__ = __webpack_require__(837)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 769:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('li', {
	    staticClass: "divider",
	    attrs: {
	      "role": "separator"
	    }
	  }), _vm._v(" "), _c('li', {
	    staticClass: "row margin-lateral-10 card"
	  }, [_c('div', {
	    staticClass: "row padding-10"
	  }, [_c('div', {
	    staticClass: "col-md-1"
	  }, [_c('i', {
	    staticClass: "fa",
	    class: _vm.fa_icon,
	    staticStyle: {
	      "margin-left": "-10px"
	    }
	  })]), _vm._v(" "), _vm._t("default")], 2)])])
	},staticRenderFns: []}

/***/ }),

/***/ 785:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.user.company) ? _c('li', {
	    staticClass: "mktp-menu dropdown",
	    class: {
	      'active': _vm.routeName.startsWith('mktp_')
	    }
	  }, [_c('router-link', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "to": {
	        name: 'mktp_home'
	      },
	      "data-toggle": "dropdown",
	      "role": "button",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, [_vm._v("\n    Pedidos"), (_vm.mktp_orders > 0) ? _c('span', {
	    staticClass: "bell-badge"
	  }, [_vm._v(_vm._s(_vm.mktp_orders))]) : _vm._e()])], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 798:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('div', {
	    staticClass: "col-md-9 margin-left-14",
	    on: {
	      "click": _vm.navigatoToCertificate
	    }
	  }, [(_vm.certificate.typeAlert === 'certificate-received') ? _c('a', [_vm._v(" Consulta " + _vm._s(_vm.getName(this.certificate.certificateName)) + " do cliente " + _vm._s(this.certificate.name) + " esta pronta  "), _c('i', {
	    staticClass: "fa fa-check text-success"
	  })]) : _vm._e(), _vm._v(" "), (_vm.certificate.typeAlert === 'certificate-creation-failed') ? _c('a', [_vm._v(" Houve um erro ao consultar a cerdidão " + _vm._s(_vm.getName(this.certificate.certificateName)) + " para o cliente. Por favor tente novamente " + _vm._s(this.certificate.name) + " "), _c('i', {
	    staticClass: "fa fa-check text-success"
	  })]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-1",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-window-close icon"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "space-50"
	  }), _vm._v(" "), _c('small', {
	    staticClass: "pull-right"
	  }, [_vm._v(_vm._s(_vm._f("time")(this.certificate.date)))])])
	},staticRenderFns: []}

/***/ }),

/***/ 826:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "dropdown",
	    class: {
	      'active': _vm.routeName.startsWith('clients_')
	    }
	  }, [(_vm.newClients) ? _c('router-link', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "data-toggle": "dropdown",
	      "role": "button",
	      "aria-haspopup": "true",
	      "aria-expanded": "false",
	      "to": {
	        name: 'clients_list'
	      }
	    }
	  }, [_vm._v("Cadastros \n       "), (_vm.newClients) ? _c('span', {
	    staticClass: "bell-badge"
	  }, [_vm._v(_vm._s(_vm.newClients))]) : _vm._e()]) : _c('router-link', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "data-toggle": "dropdown",
	      "role": "button",
	      "aria-haspopup": "true",
	      "aria-expanded": "false",
	      "to": {
	        name: 'clients_list'
	      }
	    }
	  }, [_vm._v("Cadastros \n     ")]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', {
	    staticClass: "dropdown-header"
	  }, [_vm._v("Filtros:")]), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'clients_list',
	        query: {
	          period: 6
	        }
	      }
	    }
	  }, [_vm._v("Hoje")]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'clients_list',
	        query: {
	          period: 5
	        }
	      }
	    }
	  }, [_vm._v("Ontem")])], 1), _vm._v(" "), (_vm.recentClients && _vm.recentClients.length > 0) ? [_c('li', {
	    staticClass: "divider",
	    attrs: {
	      "role": "separator"
	    }
	  }), _vm._v(" "), _c('li', {
	    staticClass: "dropdown-header"
	  }, [_vm._v("Acessados recentemente:")]), _vm._v(" "), _vm._l((_vm.recentClients), function(c, i) {
	    return _c('li', {
	      key: i
	    }, [_c('router-link', {
	      staticClass: "font-12",
	      attrs: {
	        "to": {
	          name: 'clients_details',
	          params: {
	            clientId: c.id
	          }
	        }
	      }
	    }, [_c('span', {
	      staticClass: "font-8 label",
	      class: {
	        'label-default': !c.status, 'label-warning': c.status == 0 && c.active == 1, 'label-danger': c.status == 2 || c.active == 0, 'label-success': c.status == 1 && c.active == 1
	      },
	      staticStyle: {
	        "margin": "0 5px 0 -10px",
	        "display": "inline-block"
	      }
	    }, [_vm._v("\n                    \n               ")]), _vm._v(" " + _vm._s(c.name) + "\n           ")])], 1)
	  })] : _vm._e()], 2)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 837:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.user) ? _c('nav', {
	    staticClass: "partial-header navbar navbar-default navbar-fixed-top"
	  }, [_c('div', {
	    staticClass: "container-fluid"
	  }, [_c('button', {
	    staticClass: "hidden-md hidden-lg btn btn-sm btn-default pull-right",
	    staticStyle: {
	      "margin-top": "9px"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.toggleDrawer()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-bars"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "navbar-header"
	  }, [_c('router-link', {
	    staticClass: "navbar-brand",
	    attrs: {
	      "to": {
	        name: 'home'
	      }
	    }
	  }, [_c('img', {
	    staticClass: "ls",
	    attrs: {
	      "src": _vm.imageUrl('ls.png', '50x50'),
	      "alt": "Loca.Shop"
	    }
	  }), _vm._v(" "), (_vm.user.company && _vm.user.company.image) ? _c('img', {
	    attrs: {
	      "src": _vm.user.company.image,
	      "alt": _vm.user.company.fantasy_name
	    }
	  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
	    staticClass: "hidden-xs hidden-sm"
	  }, [_c('ul', {
	    staticClass: "nav navbar-nav"
	  }, [(_vm.user.company.status) ? [_c('li', {
	    staticClass: "dropdown",
	    class: {
	      'active': _vm.routeName.startsWith('home')
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'home'
	      },
	      "title": "Home"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-lg fa-home"
	  })])], 1), _vm._v(" "), _c('registrations-menu'), _vm._v(" "), _c('li', {
	    staticClass: "dropdown",
	    class: {
	      'active': _vm.routeName.startsWith('mktp_')
	    }
	  }, [_c('router-link', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "to": {
	        name: 'mktp_home'
	      },
	      "data-toggle": "dropdown",
	      "role": "button",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, [_vm._v("\n              Pedidos"), (_vm.notificationsPanel && _vm.notificationsPanel.mktp_rents > 0) ? _c('span', {
	    staticClass: "bell-badge"
	  }, [_vm._v(_vm._s(_vm.notificationsPanel.mktp_rents))]) : _vm._e()])], 1), _vm._v(" "), _c('li', {
	    staticClass: "dropdown",
	    class: {
	      'active': _vm.routeName.startsWith('products_')
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'products_list'
	      }
	    }
	  }, [_vm._v("Produtos")])], 1), _vm._v(" "), ([1].includes(_vm.user.company.id)) ? _c('li', {
	    staticClass: "dropdown",
	    class: {
	      'active': _vm.routeName.startsWith('rents_')
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'rents_add'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-btn fa-plus"
	  }), _vm._v(" Cadastrar")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'rents_list'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-btn fa-search"
	  }), _vm._v(" Pesquisar")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'rents_dashboard',
	        params: {
	          statusId: 1
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-btn fa-bell"
	  }), _vm._v(" Painel operacional")])], 1)])]) : _vm._e(), _vm._v(" "), ([2, 3, 6, 182].includes(_vm.user.company.id)) ? _c('rent-pre-registrations-menu') : _vm._e(), _vm._v(" "), _c('general-notifications'), _vm._v(" "), ([2, 3, 6, 182].includes(_vm.user.company.id)) ? _c('chat-menu') : _vm._e(), _vm._v(" "), _c('clients-photos-menu')] : _vm._e()], 2), _vm._v(" "), _c('ul', {
	    staticClass: "nav navbar-nav navbar-right"
	  }, [(_vm.user.company.status) ? _c('router-link', {
	    staticClass: "btn btn-sm btn-success navbar-btn pull-left",
	    attrs: {
	      "to": {
	        name: 'clients_add',
	        params: {
	          statusId: 1,
	          modalVideo: true
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  }), _vm._v(" Novo cadastro")]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("  ")]), _vm._v(" "), (_vm.isCompanyAdmin()) ? _c('router-link', {
	    staticClass: "btn btn-sm btn-info navbar-btn pull-left",
	    attrs: {
	      "to": {
	        name: 'finances_dashboard',
	        query: {
	          buy_credit: 1
	        }
	      }
	    }
	  }, [_vm._v("Comprar crédito")]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("  ")]), _vm._v(" "), _c('li', {
	    staticClass: "dropdown"
	  }, [_vm._m(1), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', {
	    staticClass: "dropdown-header"
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-btn fa-user"
	  }), _vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('li', {
	    staticClass: "divider",
	    attrs: {
	      "role": "separator"
	    }
	  }), _vm._v(" "), (_vm.isCompanyAdmin()) ? _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'company_details'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-btn fa-building"
	  }), _vm._v(" Locadora")])], 1) : _vm._e(), _vm._v(" "), (_vm.isCompanyAdmin()) ? _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'employees'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-btn fa-users"
	  }), _vm._v(" Usuários")])], 1) : _vm._e(), _vm._v(" "), (_vm.isCompanyAdmin()) ? _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'shipping'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-btn fa-truck"
	  }), _vm._v(" Configurações de Frete")])], 1) : _vm._e(), _vm._v(" "), (_vm.isCompanyAdmin()) ? _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'finances_dashboard'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-btn fa-dollar"
	  }), _vm._v(" Financeiro")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
	    staticClass: "divider",
	    attrs: {
	      "role": "separator"
	    }
	  }), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": _vm.locashopURL + 'termos-de-uso',
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-btn fa-address-book"
	  }), _vm._v(" Termos de uso ")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": _vm.locashopURL + 'politicas-de-privacidade',
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-btn fa-id-badge"
	  }), _vm._v(" Política de privacidade ")])]), _vm._v(" "), _c('li', {
	    staticClass: "divider",
	    attrs: {
	      "role": "separator"
	    }
	  }), _vm._v(" "), _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.handleLogout()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-btn fa-sign-out"
	  }), _vm._v(" Sair")])])])])], 1)])])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "href": "#",
	      "data-toggle": "dropdown",
	      "role": "button",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, [_vm._v("Locações "), _c('span', {
	    staticClass: "caret"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "href": "#",
	      "data-toggle": "dropdown",
	      "role": "button",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bars"
	  })])
	}]}

/***/ }),

/***/ 839:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('div', {
	    staticClass: "col-md-10",
	    on: {
	      "click": function($event) {
	        return _vm.close(_vm.alert, true)
	      }
	    }
	  }, [(_vm.alert.data.status === 'added') ? _c('a', [_vm._v(" Locadora " + _vm._s(_vm.companyName) + " "), _c('span', {
	    staticClass: "text-danger bold"
	  }, [_vm._v(" ADICIONOU")]), _vm._v(" o cliente " + _vm._s(_vm.alert.data.client.document) + " no Painel de Alerta! ")]) : _vm._e(), _vm._v(" "), (_vm.alert.data.status === 'updated') ? _c('a', [_vm._v(" Locadora " + _vm._s(_vm.companyName) + " "), _c('span', {
	    staticClass: "text-danger bold"
	  }, [_vm._v("ATUALIZOU ")]), _vm._v(" o motivo do bloqueio do cliente " + _vm._s(_vm.alert.data.client.document) + " no Painel de Alerta! ")]) : _vm._e(), _vm._v(" "), (_vm.alert.data.status === 'removed') ? _c('a', [_vm._v(" Locadora " + _vm._s(_vm.companyName) + " "), _c('span', {
	    staticClass: "text-success bold"
	  }, [_vm._v("REMOVEU")]), _vm._v(" o cliente " + _vm._s(_vm.alert.data.client.document) + " no Painel de Alerta! ")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.alert.data.status === 'removed') ? _c('span', [_vm._v("\n\t\t\t\tMotivo: "), _c('strong', [_vm._v(" " + _vm._s(_vm.alert.data.solution) + " ")])]) : _c('span', [_vm._v("\n\t\t\t\tMotivo: "), _c('strong', [_vm._v(" " + _vm._s(_vm.alert.data.reason) + " ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-1",
	    on: {
	      "click": function($event) {
	        return _vm.close(_vm.alert)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-window-close icon"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "space-50"
	  }), _vm._v(" "), _c('small', {
	    staticClass: "pull-right"
	  }, [_vm._v(_vm._s(_vm._f("time")(_vm.alert.date)))])])
	},staticRenderFns: []}

/***/ }),

/***/ 840:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('div', {
	    staticClass: "col-md-9 margin-left-14",
	    on: {
	      "click": _vm.navigatoTo
	    }
	  }, [_c('a', [_vm._v(" \n          " + _vm._s(_vm.notify.message) + ".\n          "), _c('i', {
	    staticClass: "fa fa-check text-success"
	  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-1",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-window-close icon"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "space-50"
	  }), _vm._v(" "), _c('small', {
	    staticClass: "pull-right"
	  }, [_vm._v(_vm._s(_vm._f("time")(_vm.notify.date)))])])
	},staticRenderFns: []}

/***/ }),

/***/ 843:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('div', {
	    staticClass: "col-md-10"
	  }, [_c('a', {
	    on: {
	      "click": _vm.navigatoToBuyCredit
	    }
	  }, [_vm._v(" Seus créditos estão acabando, faça uma recarga! "), _c('strong', [_vm._v(" Saldo: " + _vm._s(_vm._f("money")(this.alert.balance)) + " ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-1",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-window-close icon"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "space-50"
	  }), _vm._v(" "), _c('small', {
	    staticClass: "pull-right"
	  }, [_vm._v(_vm._s(_vm._f("time")(_vm.alert.date)))])])
	},staticRenderFns: []}

/***/ }),

/***/ 852:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "dropdown",
	    on: {
	      "mouseenter": _vm.clearNewsNotifications
	    }
	  }, [_c('a', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "data-toggle": "dropdown",
	      "role": "button",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-bell-o",
	    staticStyle: {
	      "font-size": "1.6rem"
	    }
	  }), _vm._v(" "), (_vm.newNotification > 0) ? _c('span', {
	    staticClass: "bell-badge"
	  }, [_vm._v(" " + _vm._s(_vm.newNotification))]) : _vm._e()]), _vm._v(" "), _c('ul', {
	    ref: "dropdown",
	    staticClass: "dropdown-menu",
	    style: (Object.assign({}, (_vm.hasNotifications) ? {
	        width: '30em'
	      } : {},
	      (_vm.notifications.length >= 3) ? {
	        height: _vm.screeAvailHeight + 'px'
	      } : {},
	      {'overflow-y': (_vm.notifications.length >= 3) ? 'scroll' : 'hidden'}))
	  }, [(!_vm.hasNotifications) ? _c('li', {
	    staticClass: "dropdown-header"
	  }, [_vm._v(" \n        Nenhuma notificação recebida no momento\n      ")]) : _c('li', {
	    staticClass: "dropdown-header"
	  }, [_vm._v(" \n        Notificações gerais\n      ")]), _vm._v(" "), _vm._l((_vm.notifications), function(notification, i) {
	    return [(_vm.notifications.length > 0 && notification.typeAlert === 'balance_alert') ? _c('base-notifications', {
	      key: i,
	      attrs: {
	        "fa_icon": "fa-3x fa-dollar"
	      }
	    }, [_c('BalanceAlertNotification', {
	      key: i,
	      attrs: {
	        "alert": notification
	      },
	      on: {
	        "decreaseNotification": _vm.decreaseNotification
	      }
	    })], 1) : _vm._e(), _vm._v(" "), (_vm.notifications.length > 0 && notification.typeAlert === 'paid_pix') ? _c('base-notifications', {
	      key: i,
	      attrs: {
	        "fa_icon": "fa-3x fa-dollar"
	      }
	    }, [_c('PixNotification', {
	      key: i,
	      attrs: {
	        "pix": notification
	      },
	      on: {
	        "decreaseNotification": _vm.decreaseNotification
	      }
	    })], 1) : _vm._e(), _vm._v(" "), (_vm.notifications.length > 0 && notification.typeAlert === 'alert-panel') ? _c('base-notifications', {
	      key: i,
	      attrs: {
	        "fa_icon": "fa-2x fa-warning"
	      }
	    }, [_c('alert-panel-notification', {
	      attrs: {
	        "alert": notification
	      },
	      on: {
	        "decreaseNotification": _vm.decreaseNotification
	      }
	    })], 1) : _vm._e(), _vm._v(" "), (_vm.notifications.length > 0 &&
	      (notification.typeAlert === 'certificate-received' || notification.typeAlert === 'certificate-creation-failed')) ? _c('base-notifications', {
	      key: i,
	      attrs: {
	        "fa_icon": "fa-3x fa-file-code-o"
	      }
	    }, [_c('certificate-ready-notification', {
	      attrs: {
	        "certificate": notification
	      },
	      on: {
	        "decreaseNotification": _vm.decreaseNotification
	      }
	    })], 1) : _vm._e(), _vm._v(" "), (_vm.notifications.length > 0 &&
	      notification.typeAlert === 'client_added' || notification.typeAlert === 'status_changed') ? _c('base-notifications', {
	      key: i,
	      attrs: {
	        "fa_icon": "fa-2x fa-users"
	      }
	    }, [_c('notify-user-on-client', {
	      attrs: {
	        "notifyUser": notification
	      },
	      on: {
	        "decreaseNotification": _vm.decreaseNotification
	      }
	    })], 1) : _vm._e(), _vm._v(" "), (_vm.notifications.length > 0 &&
	      notification.typeAlert === 'notify_boleto_payment') ? _c('base-notifications', {
	      key: i,
	      attrs: {
	        "fa_icon": "fa-2x fa-money"
	      }
	    }, [_c('notify-boleto-payment', {
	      attrs: {
	        "notify": notification
	      },
	      on: {
	        "decreaseNotification": _vm.decreaseNotification
	      }
	    })], 1) : _vm._e()]
	  })], 2)])
	},staticRenderFns: []}

/***/ }),

/***/ 858:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('div', {
	    staticClass: "col-md-9 margin-left-14",
	    on: {
	      "click": _vm.navigatoTo
	    }
	  }, [(_vm.notifyUser.typeAlert === 'status_changed') ? _c('a', [_vm._v(" \n\t\t\t\t\t" + _vm._s(_vm.notifyUser.actionedByUser.name) + " " + _vm._s(_vm.notifyUser.status) + " cadastro do cliente " + _vm._s(_vm.notifyUser.client.name) + ".\n\t\t\t\t\t"), _c('i', {
	    staticClass: "fa fa-check text-success"
	  })]) : _vm._e(), _vm._v(" "), (_vm.notifyUser.typeAlert === 'client_added') ? _c('a', [_vm._v(" \n\t\t\t\t" + _vm._s(_vm.notifyUser.actionedByUser.name) + " acabou de inseriu um novo cadastro de cliente. Nome: " + _vm._s(_vm.notifyUser.client.name) + ".\n\t\t\t\t"), _c('i', {
	    staticClass: "fa fa-check text-success"
	  })]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-1",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-window-close icon"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "space-50"
	  }), _vm._v(" "), _c('small', {
	    staticClass: "pull-right"
	  }, [_vm._v(_vm._s(_vm._f("time")(_vm.notifyUser.date)))])])
	},staticRenderFns: []}

/***/ }),

/***/ 874:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('div', {
	    staticClass: "col-md-10",
	    on: {
	      "click": function($event) {
	        return _vm.close(_vm.pix, true)
	      }
	    }
	  }, [_vm._v("\n\t\t\tRecebemos pagamento via PIX do pedido #" + _vm._s(_vm.pix.transaction_id) + ", obrigado! \n\t\t\t"), _c('div', {
	    staticClass: "space-10"
	  }), _vm._v(" "), _c('strong', {
	    staticClass: "font-16"
	  }, [_vm._v(" Valor da Recarga: " + _vm._s(_vm._f("money")(_vm.pix.balance)) + " ")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-1",
	    on: {
	      "click": function($event) {
	        return _vm.close(_vm.pix)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-window-close icon"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "space-50"
	  }), _vm._v(" "), _c('small', {
	    staticClass: "pull-right"
	  }, [_vm._v(_vm._s(_vm._f("time")(_vm.pix.date)))])])
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.7edcd22e88b4ff384fa5.js